<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-50 md-small-size-50 order-header">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>equalizer</md-icon>
          </div>
          <p class="category">CLOOSIV REVENUE</p>
          <h3 class="title">{{ formatDouble(revenueTotal) }}</h3>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-size-50 md-small-size-50 order-header">
      <stats-card header-color="green">
        <template slot="header">
          <div class="card-icon">
            <md-icon>equalizer</md-icon>
          </div>
          <p class="category"># OF LOCATIONS</p>
          <h3 class="title">
            <animated-number :key="summary_total" :value="summary_total"></animated-number>
          </h3>
        </template>
      </stats-card>
    </div>
    <div class="md-layout-item md-size-100">
      <div class="md-gutter md-alignment-top-right">
        <date-range-picker v-model="calendarPeriod" :startDate="calendarPeriod.startDate" :endDate="calendarPeriod.endDate" :locale-data="calendarLocale" :ranges="ranges" opens="right">
          <md-input v-model="calendarPeriod" slot-scope="picker">Days Interval</md-input>
        </date-range-picker>
      </div>
    </div>
    <div class="md-layout-item md-size-100">
      <div class="md-layout">
        <div class="md-layout-item">
          <md-card>
            <md-card-header class="md-card-header-icon md-card-header-green">
              <div class="card-icon">
                <md-icon>assignment</md-icon>
              </div>
              <h4 class="title">Merchant Report</h4>
            </md-card-header>
            <md-card-content>
              <md-table id="ordersInfoTable" :value="summaries" class="paginated-table table-striped table-hover">
                <md-table-row slot="md-table-row" slot-scope="{ item }">
                  <md-table-cell md-label="Name"> {{ item.name }} </md-table-cell>
                  <md-table-cell md-label="Address"> {{ item.street_address }} </md-table-cell>
                  <md-table-cell md-label="# Orders">{{item.order_count}}</md-table-cell>
                  <md-table-cell md-label="# Customers">{{ item.customer_count }}</md-table-cell>
                  <md-table-cell md-label="Revenue">{{ formatDouble(item.revenue) }}</md-table-cell>
                  <md-table-cell md-label="Tax">{{ formatDouble(item.tax) }}</md-table-cell>
                  <md-table-cell md-label="Tip">{{ formatDouble(item.tips) }}</md-table-cell>
                  <md-table-cell md-label="Total">{{ formatDouble(item.total) }}</md-table-cell>
                  <md-table-cell md-label="Square">{{ formatDouble(item.fee) }}</md-table-cell>
                  <md-table-cell md-label="Deposit">{{ formatDouble(item.deposit) }}</md-table-cell>
                  <md-table-cell md-label="Cloosiv">{{ formatDouble(item.cloosiv_fee) }}</md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
            <md-card-actions md-alignment="space-between">
              <div class="">
                <p class="card-category">
                  Showing {{ summary_from + 1 }} to {{ summary_to }} of {{ summary_total }} entries
                </p>
              </div>
              <pagination class="pagination-no-border pagination-success" v-model="summaryHandleProps.currentPage" :per-page="summaryHandleProps.perPage" :total="summary_total">
              </pagination>
            </md-card-actions>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment"
import { Pagination, StatsCard, AnimatedNumber } from "@/components";
import DateRangePicker from 'vue2-daterange-picker';
import JsonCSV from 'vue-json-csv'
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css'

export default {
  name: "MerchantOrdersReportV2",
  components: {
    Pagination,
    StatsCard,
    AnimatedNumber,
    DateRangePicker,
    'downloadCsv': JsonCSV
  },
  computed: {
    summary_from() {
      return this.summaryHandleProps.perPage * (this.summaryHandleProps.currentPage - 1);
    },
    summary_to() {
      let highBound = this.summary_from + this.summaryHandleProps.perPage;
      if (this.summary_total < highBound) {
        highBound = this.summary_total;
      }
      return highBound;
    },
    summary_total() {
      return this.summaries_pagination.total;
    }
  },
  data() {
    return {
      summaries: {},
      summaries_pagination: {
        total: 0
      },
      propsToSearch: ["name"],
      summaryHandleProps: {
        searchQuery: "",
        currentPage: 1,
        perPage: 1000
      },
      calendarPeriod: {
        startDate: moment().startOf('day'),
        endDate: moment().endOf('day')
      },
      dateStart: moment().startOf('day'),
      dateEnd: moment().endOf('day'),
      calendarLocale: {
        direction: 'ltr',
        format: 'MM/DD/YYYY',
        separator: ' - ',
        applyLabel: 'Apply',
        cancelLabel: 'Cancel',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: moment.weekdaysMin(),
        monthNames: moment.monthsShort(),
        firstDay: 0,
        showWeekNumbers: true
      },
      ranges: {
        'Today': [moment(), moment()],
        'Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
        'Last week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
        'This month': [moment().startOf('month'), moment().endOf('month')],
        'Last month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
        'This year': [moment().startOf('year'), moment().endOf('year')]
      },
      formatter: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD'
      }),
      revenueTotal: 0.0
    }
  },
  created() {
    this.getMerchantSummaries()
  },
  methods: {
    getMerchantSummaries() {
      this.$http.secured.get(`/v2/orders/merchantreport` +
          `?page=${this.summaryHandleProps.currentPage}` +
          `&page_count=${this.summaryHandleProps.perPage}` +
          `&end_date=${this.dateEnd}&start_date=${this.dateStart}`)
        .then(this.summaryData)
        .catch(error => alert(error))
    },
    summaryData(response) {
      this.summaries = response.data.merchants;
      this.summaries_pagination.total = response.data.meta.total
      this.calculateCloosivPercentage()
    },
    formatDouble(value) {
      var parsedValue = parseFloat(value)
      return this.formatter.format(parsedValue)
    },
    calculateCloosivPercentage() {
      this.revenueTotal = 0.0

      for (var merchant of this.summaries) {
        var cloosiv_fee = (merchant.amount_owed_cents * 0.01)
        merchant.cloosiv_fee = cloosiv_fee
        this.revenueTotal += cloosiv_fee
      }
    }
  },
  filters: {
    moment: function(date) {
      return moment(date).format('MM/DD/YY hh:mm A');
    }
  },
  watch: {
    summaryHandleProps: {
      handler() {
        this.getMerchantSummaries()
      },
      deep: true
    },
    calendarPeriod: {
      handler() {
        this.dateStart = moment(this.calendarPeriod.startDate).startOf('day')
        this.dateEnd = moment(this.calendarPeriod.endDate).endOf('day')
        this.getMerchantSummaries()
      },
      deep: true
    }
  }
}
</script>

<style lang="scss">
#ordersInfoTable tr td:first-child {
  max-width: 1% !important;
  white-space: nowrap;
}

#ordersInfoTable tr td:nth-child(2) {
  max-width: 1% !important;
  white-space: nowrap;
}

#ordersInfoTable.paginated-table .md-table-cell:last-child .md-table-cell-container, .paginated-table .md-table-head:last-child {
  text-align: unset !important;
  justify-content: left;
}
</style>